enum YesNoEnum {
    YES = 'YES',
    NO = 'NO',
}

export default YesNoEnum;
